const convertScreamingSnakeCaseToCamelCase = string => {
  return string.toLowerCase().replace(/_([a-z])/g, (__match, letter) => {
    return letter.toUpperCase();
  });
};
export const transformToLegacyPurchaseMotionsShape = (locations, evaluationResponse) => {
  const legacyPurchaseMotions = {};
  for (const location of locations) {
    const purchaseMotionsByApiName = {};
    const purchaseMotionsByProvidedLocation = evaluationResponse.purchaseMotionsMapping.productsByLocation[location];
    for (const [apiName, purchaseMotionsForApiName] of Object.entries(purchaseMotionsByProvidedLocation.purchaseMotionsByProductApiName)) {
      purchaseMotionsByApiName[apiName] = purchaseMotionsForApiName.purchaseMotions.map(purchaseMotion => {
        return {
          key: convertScreamingSnakeCaseToCamelCase(purchaseMotion.toString())
        };
      });
    }
    legacyPurchaseMotions[location] = {
      purchaseMotions: purchaseMotionsByApiName
    };
  }
  return legacyPurchaseMotions;
};